function SearchIcon(props) {
  return (
    <svg width={18} height={18} fill="#fff" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.046 4.176a3.876 3.876 0 013.87 3.87c0 .81-.252 1.566-.72 2.232l-.378.54-.54.378a3.836 3.836 0 01-2.232.72 3.876 3.876 0 01-3.87-3.87 3.876 3.876 0 013.87-3.87zm0-1.926A5.792 5.792 0 002.25 8.046a5.792 5.792 0 005.796 5.796 5.717 5.717 0 003.348-1.08l2.718 2.718c.18.18.432.288.684.288.252 0 .504-.09.684-.288l.018-.018c.378-.378.432-1.008 0-1.368l-2.718-2.7c.666-.954 1.08-2.106 1.08-3.348-.018-3.204-2.61-5.796-5.814-5.796z" />
    </svg>
  )
}

export default SearchIcon
